var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"max-width":"1200px","margin":"auto"}},[_c('checkfront',{attrs:{"productID":_vm.query.checkfrontProductID || '3',"language":_vm.query.language || 'en'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }